import { breakpoint } from '../../../styling/mixins/breakpoints';
import styled from 'styled-components';
import { getColor } from '../../../styling/mixins/colors';
import { fontFamilyBold, text } from '../../../styling/mixins/typography';
import { header } from '../../../styling/mixins/typography';

import {
  alignCenter,
  displayFlex,
  flexColumn,
  justifyCenter,
} from '../../../styling/utils/flex';
import Icon from '../../Icon';

interface StyledSideMenuProps {
  $from: string;
  $open: boolean;
}

export const StyledSideMenu = styled.div<StyledSideMenuProps>`
  ${displayFlex}
  ${flexColumn}
  position: fixed;
  z-index: 50;
  top: 0;
  height: 100%;
  width: 100%;
  background-color: ${getColor('white')};
  transition: all ease-in-out 0.4s;
  max-width: 640px;
  .title {
    padding: 1.6rem;
  }

  ${breakpoint('medium')} {
    width: 640px;
  }

  left: ${(p) => (p.$from == 'left' ? '-100%' : 'unset')};
  right: ${(p) => (p.$from == 'right' ? '-100%' : 'unset')};

  &.open {
    left: ${(p) => (p.$from == 'left' && p.$open ? '0' : 'unset')};
    right: ${(p) => (p.$from == 'right' && p.$open ? '0' : 'unset')};
  }

  &.closing {
    left: ${(p) => (p.$from == 'left' ? '-100' : 'unset')};
    right: ${(p) => (p.$from == 'right' ? '-100' : 'unset')};
  }

  .error {
    ${text('small')}
    color: ${getColor('alert')};
    margin-bottom: 1.6rem;
  }
`;

export const StyledSideMenuHeader = styled.div`
  ${displayFlex}
  ${alignCenter}
  position: relative;
  border-bottom: 1px solid ${getColor('grey', 300)};
  max-height: 56px;
  padding: 1.6rem;
  background: ${getColor('white')};

  h4 {
    ${text('xlarge')};
    ${fontFamilyBold};
  }
`;

export const StyledSideMenuFooter = styled.div`
  ${displayFlex}
  ${justifyCenter}
  border-top: 1px solid ${getColor('grey', 300)};
  padding: 1.6rem;
`;

export const StyledSideMenuCloseButton = styled.button`
  position: absolute;
  top: 1.6rem;
  right: 1.6rem;
  cursor: pointer;
  font-size: 2.4rem;

  ${breakpoint('small', 'only')} {
    font-size: 2rem;
  }
`;

export const StyledSideMenuContent = styled.div`
  padding-left: 1.6rem;
  padding-right: 1.6rem;
  gap: 1.6rem;
`;
